import { ApiCore } from './utilities/core'


export const logoutApi = new ApiCore({
  getAll: true,
  url: 'api/logout',
})
